const initialState = {
    isLoading: true,
    docs: []
};

export default (state = initialState, action) => {
    switch (action.type) {
    case 'FETCH_PHOTOS_RT_PROCESS':
        return { 
            ...state,
            isLoading: true
        };
    case 'FETCH_PHOTOS_RT_SUCCESS':
        return { 
            ...state,
            isLoading: false,
            docs: action.data
        };
    case 'FETCH_PHOTOS_RT_ERROR':
        return { 
            ...state,
            isLoading: true,
            docs: null
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/photovideo.reducer.js